// Color palette extracted from the design system
export const COLORS = {
  // Core brand colors
  BRAND: {
    PRIMARY_BLACK: '#0D0E20',  // Logo background and primary dark
    WHITE: '#FFFFFF',          // Primary text and backgrounds
  },

  // State colors
  SUCCESS: {
    PRIMARY: '#10B981',        // Green for success states
    LIGHT: '#D1FAE5',         // Light green backgrounds
    DARK: '#059669',          // Darker green for hover states
  },

  ERROR: {
    PRIMARY: '#EF4444',        // Red for error states
    LIGHT: '#FEE2E2',         // Light red backgrounds
    BORDER: '#FCA5A5',        // Error border color
  },

  // Input and form colors
  INPUT: {
    BORDER: 'rgba(0, 0, 0, 0.4)',  // Input border (black 40% opacity)
    BORDER_LIGHT: 'rgba(0, 0, 0, 0.2)', // Lighter border variant
    BACKGROUND: '#FFFFFF',      // Input background
    PLACEHOLDER: '#6B7280',     // Placeholder text color
  },

  // Background colors
  BACKGROUND: {
    OVERLAY: 'rgba(0, 0, 0, 0.6)',     // Modal overlay
    BLUR_LIGHT: 'rgba(255, 255, 255, 0.1)', // Light blur background
    BLUR_MEDIUM: 'rgba(255, 255, 255, 0.2)', // Medium blur background
    BLUR_STRONG: 'rgba(255, 255, 255, 0.95)', // Strong blur background
  },

  // Mobile-specific colors
  MOBILE: {
    BG_START: '#FFB6C1',       // Light pink starting point
    BG_END: '#87CEEB',         // Light blue ending point
    GRASS: '#4ADE80',          // Green grass color
    SUCCESS_BG: '#1F2937',     // Dark background for success state
    REFER_ACCENT: '#FCD34D',   // Yellow accent for refer button
  },

  // Gradient definitions
  GRADIENTS: {
    MOBILE_BG: 'linear-gradient(180deg, #FFB6C1 0%, #E0B4D6 25%, #A8C8EC 75%, #87CEEB 100%)',
    BLUE_GREEN: 'linear-gradient(to right, #2563EB, #059669)',
    BLUE_GREEN_HOVER: 'linear-gradient(to right, #1D4ED8, #047857)',
  },

  // Text colors with opacity
  TEXT: {
    PRIMARY: '#000000',
    SECONDARY: '#6B7280',
    WHITE: '#FFFFFF',
    WHITE_80: 'rgba(255, 255, 255, 0.8)',
    WHITE_90: 'rgba(255, 255, 255, 0.9)',
    BLACK_80: 'rgba(0, 0, 0, 0.8)',
  },

  // Button colors
  BUTTON: {
    PRIMARY_BG: '#FFFFFF',
    PRIMARY_TEXT: '#000000',
    PRIMARY_HOVER: '#F9FAFB',
    
    SUCCESS_BG: '#10B981',
    SUCCESS_TEXT: '#FFFFFF',
    SUCCESS_HOVER: '#059669',
    
    DARK_BG: '#1F2937',
    DARK_TEXT: '#FFFFFF',
    DARK_HOVER: '#374151',
  },
};

// Shadow definitions
export const SHADOWS = {
  BUTTON: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
  BUTTON_HOVER: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
  MODAL: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
  CARD: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
};